import React, { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Alert, AlertDescription, AlertTitle } from '../../components/ui/alert';
import { AdblockLegacyFilters, LegacyFilters } from '../../components/dashboards/adblock-legacy/AdblockLegacyFilters';


export const AdblockLegacyDashboardPage: React.FC = () => {
  const { currentUser } = useAuth();
  const [networkId, setNetworkId] = useState<number | null>(null); // TODO: derive from auth/user context if available
  const [currentFilters, setCurrentFilters] = useState<LegacyFilters | null>(null);
  // Placeholder error handling (à ajouter quand les appels métriques seront implémentés)
  const [error] = useState<string | null>(null);
  // Future: filters state will be managed via AdblockLegacyFilters component

  // Assumption: networkId might be part of user custom claims or profile; placeholder logic
  useEffect(() => {
    // If your auth context provides a networkId, set it here. Placeholder set to 1 for now.
    if (!networkId) {
      setNetworkId(1); // Assumption; replace when real value available
    }
  }, [networkId]);

  // Domaines chargés directement via le composant AdblockLegacyFilters

  if (!currentUser) {
    return (
      <div className="p-6">
        <Alert variant="destructive">
          <AlertTitle>Erreur</AlertTitle>
          <AlertDescription>Vous devez être connecté pour accéder à cette page.</AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className="min-h-[calc(100vh-7rem)] overflow-auto">
      <div className="p-6 space-y-6">
        {/* Header */}
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-3xl font-bold">Adblock Legacy</h1>
            <p className="text-muted-foreground mt-1">Suivi des performances pour les domaines avec abonnement Adblock Legacy actif</p>
          </div>
        </div>

        {/* Filters Component */}
        {networkId && (
          <AdblockLegacyFilters
            networkId={networkId}
            onChange={(f) => setCurrentFilters(f)}
          />
        )}

        {error && (
          <Alert variant="destructive">
            <AlertTitle>Erreur</AlertTitle>
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}

        {/* Summary Placeholder */}
        <Card className="opacity-70">
          <CardHeader>
            <CardTitle>Résumé (placeholder)</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {Array.from({ length: 4 }).map((_, i) => (
                <Card key={i} className="border-dashed">
                  <CardContent className="p-6">
                    <div className="h-4 w-1/2 bg-muted rounded mb-4" />
                    <div className="h-6 w-1/3 bg-muted rounded" />
                  </CardContent>
                </Card>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Chart Placeholder */}
        <Card className="opacity-70">
          <CardHeader>
            <CardTitle>Graphiques (placeholder)</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="h-80 w-full flex items-center justify-center text-muted-foreground text-sm">
              Section graphique à venir {currentFilters ? `(domains: ${currentFilters.domains.length})` : ''}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdblockLegacyDashboardPage;